import { render } from "./Registered.vue?vue&type=template&id=748e54fc"
import script from "./Registered.vue?vue&type=script&lang=js"
export * from "./Registered.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Dashboard/Type/Registered.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "748e54fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('748e54fc', __exports__)) {
    api.reload('748e54fc', __exports__)
  }
  
  module.hot.accept("./Registered.vue?vue&type=template&id=748e54fc", () => {
    api.rerender('748e54fc', render)
  })

}


export default __exports__